// extracted by mini-css-extract-plugin
module.exports = {"expired":"SessionExpiredPage_expired__2m-2I","continue":"SessionExpiredPage_continue__kLkZh","message":"SessionExpiredPage_message__3ubjo"};